import { Link } from 'react-router-dom';
import { tvSeriesData, type TVSeries } from '@/mocks/tvSeries';

export default function HotRecommend() {
  const hotSeries = tvSeriesData.filter((s) => s.isHot);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热播推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">大家都在追的热门好剧</p>
          </div>
          <Link
            to="/category/hot"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotSeries.map((series) => (
            <SeriesCard key={series.id} series={series} />
          ))}
        </div>
      </div>
    </section>
  );
}

function SeriesCard({ series }: { series: TVSeries }) {
  return (
    <Link
      to={`/article/${series.id}`}
      className="group cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
        <img
          src={series.posterImage}
          alt={`${series.title} - 红桃影院高清在线观看`}
          title={`${series.title} ${series.category} ${series.year}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-md">
            {series.rating}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          {series.isNew && (
            <span className="px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-md">
              NEW
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-white text-xs leading-relaxed line-clamp-2">{series.description}</p>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
        {series.title}
      </h3>
      <div className="flex items-center gap-1.5 mt-1">
        <span className="text-xs text-foreground-500">{series.category}</span>
        <span className="text-xs text-foreground-400">·</span>
        <span className="text-xs text-foreground-500">{series.status}</span>
      </div>
    </Link>
  );
}